/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as MatStyled from "@mui/material/styles";
import styled from "styled-components";
import moment from "moment";
import device from "src/styles/device";
import useDeviceSize from "src/hooks/useDeviceSize";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";

import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getAllOrder } from "src/api/wallplast";
import { convertIntToCurrency } from "src/common";
import { useAuth } from "src/hooks/useAuth";

const DivMuiContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  justify-content: center;
  align-items: center;

  @media ${device.tabletL} {
    padding: 0;
    border-radius: 0;
    box-shadow: none;
  }
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
`;

const WrapperSearch = styled.div`
  margin-right: 16px;
  width: 65%;
  position: relative;
  display: flex;
  justify-content: center;

  @media ${device.tabletL} {
    width: 70%;
  }
  @media ${device.tablet} {
    width: 65%;
  }
  @media ${device.mobileL} {
    width: 85%;
  }

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
  .MuiTextField-root {
    margin: 0;
  }
`;

// const WrapperButton = styled.div`
//   padding: 0px;
//   width: 35%;
//   max-width: 350px;
//   margin-left: 16px;

//   @media ${device.tabletL} {
//     width: 30%;
//   }
//   @media ${device.tablet} {
//     width: 35%;
//   }
//   @media ${device.mobileL} {
//     width: max-content;
//     max-width: 32px;
//     margin-left: 14px;
//   }

//   .Button-Add {
//     width: 100%;
//     box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
//       0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
//     border-radius: 16px;
//     height: 52px;
//     padding: 12px 24px;
//   }
//   .Button-Add:focus {
//     background-color: #e04132;
//   }
//   .Button-Add:hover {
//     background-color: #e04132;
//     opacity: 0.9;
//   }
// `;

//   /* width: ${({ half }) => (half ? "48.5%" : "100%")}; */
//   width: max-content;

//   @media ${device.tabletL} {
//     max-width: ${({ half }) => (half ? "250px" : "530px")};

//     ${({ left, right }) =>
//       left
//         ? css`
//             margin-left: auto;
//           `
//         : right
//         ? css`
//             margin-right: auto;
//           `
//         : css`
//             margin: 0 auto;
//           `}
//   }

//   .TextField-without-border-radius fieldset {
//     border-radius: 24px;
//     // text-align: center;
//     // background: #fff;
//   }
//   .TextField-without-border-radius-amount fieldset {
//     border-radius: 24px;
//     width: 100%;
//     text-align: center;
//     background: #fff;
//   }
//   .MuiAutocomplete-root {
//     /* margin: ${({ item }) => (item ? "0" : "24px 0")}; */
//     margin: 0;
//   }
//   .MuiOutlinedInput-input {
//     background: #fff;
//     /* border-radius: 24px; */
//     /* padding: 16px 14px; */
//   }
//   .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl {
//     padding-right: 14px;
//   }
//   .MuiInputBase-root-MuiOutlinedInput-root {
//     border-radius: 24px;
//     background: #fff;
//   }
//   .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
//     border-radius: 24px;
//   }

//   .MuiTextField-root {
//     border-radius: 24px;
//   }
//   .MuiOutlinedInput-root {
//     border-radius: 24px;
//   }
//   .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
//     padding: 7.5px 0
//   }
// `;

const DivFilterSection = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  background: var(--white-color);

  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }

  @media ${device.tabletL} {
    height: 70dvh;
    border-radius: 24px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);

    .MuiDataGrid-root {
      border-radius: 16px;
    }
    .MuiDataGrid-columnHeaders {
      border-radius: 16px 16px 0 0;
    }
    .MuiDataGrid-columnHeader:first-child,
    .MuiDataGrid-cell:first-child {
      padding-left: 32px;
    }
    .MuiDataGrid-columnHeader:last-child,
    .MuiDataGrid-cell:last-child {
      padding-right: 32px;
    }
  }
  @media ${device.mobileL} {
    border-radius: 16px;

    .MuiDataGrid-root {
      border-radius: 16px;
    }
    .MuiDataGrid-columnHeaders {
      border-radius: 16px 16px 0 0;
    }
    .MuiDataGrid-columnHeader:first-child,
    .MuiDataGrid-cell:first-child {
      padding-left: 16px;
    }
    .MuiDataGrid-columnHeader:last-child,
    .MuiDataGrid-cell:last-child {
      padding-right: 16px;
    }
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: "16px 20px",
  [theme.breakpoints.up("sm")]: {
    padding: "24px 40px",
  },
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3),
  },
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  width: "100%",
  marginTop: "75px",
  background: "#fff",
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const WallplastList = ({ open }) => {
  const { user } = useAuth();

  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    filter: "all",
    page: 0,
    page_size: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [orderList, setOrderList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [deviceWidth] = useDeviceSize();
  const navigate = useNavigate();

  const onSearchButton = () => {
    setDataSearch({ ...dataSearch });
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        fetchOrder({ ...dataSearch });
      }
    })();
  };

  const DesktopColumns = [
    {
      field: "createdAt",
      headerName: "Date",
      flex: 1.1,
      headerAlign: "left",
      align: "left",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              // width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.createdAt
              ? moment(params?.row?.createdAt).format("DD/MM/YYYY")
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "ref_code", //
      headerName: "Reference No.",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.ref_code}
          </Box>
        );
      },
    },
    {
      field: "info_user",
      headerName: "Customer Name",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {`${params?.row?.info_user?.first_name} ${params?.row?.info_user?.last_name}`}
          </Box>
        );
      },
    },
    {
      field: "sale_code",
      headerName: "Sale Code",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.sale_code ? params?.row?.sale_code : "-"}
          </Box>
        );
      },
    },
    {
      field: "name",
      headerName: "Theme",
      flex: 1.5,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {`${params?.row?.name}`}
          </Box>
        );
      },
    },
    {
      field: "price",
      headerName: "Price",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {!!params?.row?.discountPercent
              ? `฿${convertIntToCurrency(
                  params?.row?.group_price?.discount,
                  false,
                )}`
              : `฿${convertIntToCurrency(
                  params?.row?.group_price?.net_price,
                  false,
                )}`}
          </Box>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/wallplast/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  const MobileColumns = [
    {
      field: "createdAt", // ?
      headerName: "Date",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
            }}
          >
            {params?.row?.createdAt
              ? moment(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </Box>
        );
      },
    },
    {
      field: "customer_name",
      headerName: "Name",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              wordWrap: "break-word",
              py: 2,
              ...(params?.row?.status === "available" && {
                color: "var(--blue-color)",
              }),
              ...(params?.row?.status === "timeout" && {
                color: "var(--primary-color)",
              }),
            }}
          >
            {params?.row?.customer_name}
          </Box>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/sale-order/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  const handlePageChange = (newPage) => {
    setDataSearch({ ...dataSearch, page: newPage });
  };

  const NoRowsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  };

  const NoResultsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  };

  const fetchOrder = async (dataSearch = {}) => {
    if (user.role_id === 1) {
      const { data } = await getAllOrder(dataSearch);
      setOrderList(data.data);
      setRowCount(data.count);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchOrder({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page]);

  return (
    <Main open={open}>
      <DivMuiContainer>
        <DivMuiInside>
          <WrapperSearch>
            <TextField
              id="search-input"
              placeholder="ค้นหาจากรหัสอ้างอิง รหัสเซลล์ ชื่อของลูกค้า"
              className="TextField-without-border-radius"
              sx={{
                m: 1,
                width: "100%",
                borderRadius: "16px",
              }}
              InputProps={{
                endAdornment: (
                  <IconButton
                    id="button-search-quotation"
                    sx={{ padding: 0 }}
                    onClick={() => onSearchButton()}
                  >
                    <SearchIcon sx={{ color: "#e04132", cursor: "pointer" }} />
                  </IconButton>
                ),
              }}
              onChange={(e) => {
                setDataSearch({
                  ...dataSearch,
                  keyword: e.target.value,
                  status: !!e.target.value ? 0 : "all",
                });
              }}
              onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
            />
          </WrapperSearch>
        </DivMuiInside>

        {deviceWidth > 835 && (
          <DivFilterSection>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  mr: 2,
                }}
                component="span"
              >
                ออเดอร์ทั้งหมด :{" "}
                <Typography
                  component="span"
                  sx={{
                    color: "#E13B30",
                  }}
                >
                  {rowCount}
                </Typography>
              </Typography>
            </Box>
          </DivFilterSection>
        )}

        <WrapperDataGrid>
          <DataGrid
            rows={orderList}
            getRowId={(row) => row._id}
            getRowHeight={() => "auto"}
            loading={isLoading}
            columns={deviceWidth > 835 ? DesktopColumns : MobileColumns}
            pageSize={10}
            rowCount={rowCount}
            paginationMode="server"
            page={dataSearch.page}
            onPageChange={(e) => handlePageChange(e)}
            rowsPerPageOptions={[10]}
            pagination
            disableSelectionOnClick
            components={{
              NoRowsOverlay,
              NoResultsOverlay,
            }}
            componentsProps={{
              basePopper: {},
            }}
            sx={{
              [`& .${gridClasses.row}.odd`]: {
                backgroundColor: "var(--darkwhite-color)",
                "&:hover": {
                  backgroundColor: "#f3f1f269",
                  "@media (hover: none)": {
                    backgroundColor: "transparent",
                  },
                },
              },
              "& .MuiDataGrid-actionsCell": {
                transform: "rotate(90deg)",
              },
              ".MuiDataGrid-row": {
                minHeight: {
                  xs: "60px !important",
                  md: "80px !important",
                },
              },
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
          />
        </WrapperDataGrid>
      </DivMuiContainer>
    </Main>
  );
};

export default WallplastList;
